import { getTermsValue } from '@/packages/JsonQuery';
import { EHeatingType } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagHeatingSourceTypeSchema } from '../types';

const TEXT_MAP: { [key in EHeatingType]: string } = {
  [EHeatingType.Furnace]: 'Печь',
  [EHeatingType.Fireplace]: 'Камин',
  [EHeatingType.None]: 'Без отопления',
  [EHeatingType.Gas]: 'Центральное газовое',
  [EHeatingType.Coal]: 'Угольное отопление',
  [EHeatingType.Electric]: 'Электрическое',
  [EHeatingType.AutonomousGas]: 'Автономное газовое',
  [EHeatingType.Diesel]: 'Дизельное',
  [EHeatingType.SolidFuelBoiler]: 'Твердотопливный котел',
};

export const heatingSourceType: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermsValue('heating_source_type')(jsonQuery) || [];

    const tagsGroup: TagHeatingSourceTypeSchema[] = value.map(key => ({
      group: 'heatingSourceType',
      text: TEXT_MAP[key],
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagHeatingSourceTypeSchema) {
    const currentValue = getTermsValue('heating_source_type')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setHeatingSourceTypes',
      arguments: [nextValue],
    });
  },
};
